import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/game/all.png")